module.exports = __webpack_public_path__ + "img/mock_qr.bd1ef37c.png";